import { jsx as _jsx } from "react/jsx-runtime";
import { buttonClasses } from "@mui/material/Button";
// components
import { Icon } from "@iconify/react";
import { Calendar2 } from "iconsax-react";
// ----------------------------------------------------------------------
const dateList = [
    "DatePicker",
    "DateTimePicker",
    "StaticDatePicker",
    "DesktopDatePicker",
    "DesktopDateTimePicker",
    //
    "MobileDatePicker",
    "MobileDateTimePicker",
];
const timeList = [
    "TimePicker",
    "MobileTimePicker",
    "StaticTimePicker",
    "DesktopTimePicker",
];
const switchIcon = () => _jsx(Icon, { icon: "eva:chevron-down-fill", width: 24 });
const leftIcon = () => _jsx(Icon, { icon: "eva:arrow-ios-back-fill", width: 24 });
const rightIcon = () => _jsx(Icon, { icon: "eva:arrow-ios-forward-fill", width: 24 });
const calendarIcon = () => _jsx(Calendar2, { size: "24px", color: "#212B36" });
const clockIcon = () => _jsx(Icon, { icon: "solar:clock-circle-outline", width: 24 });
const desktopTypes = dateList.reduce((result, currentValue) => {
    result[`Mui${currentValue}`] = {
        defaultProps: {
            slots: {
                openPickerIcon: calendarIcon,
                leftArrowIcon: leftIcon,
                rightArrowIcon: rightIcon,
                switchViewIcon: switchIcon,
            },
        },
    };
    return result;
}, {});
const timeTypes = timeList.reduce((result, currentValue) => {
    result[`Mui${currentValue}`] = {
        defaultProps: {
            slots: {
                openPickerIcon: clockIcon,
                rightArrowIcon: rightIcon,
                switchViewIcon: switchIcon,
            },
        },
    };
    return result;
}, {});
export function datePicker(theme) {
    return {
        MuiPickersLayout: {
            styleOverrides: {
                root: {
                    "& .MuiPickersLayout-actionBar": {
                        [`& .${buttonClasses.root}:last-of-type`]: {
                            backgroundColor: theme.palette.text.primary,
                            color: theme.palette.mode === "light"
                                ? theme.palette.common.white
                                : theme.palette.grey[800],
                        },
                    },
                },
            },
        },
        // Date
        ...desktopTypes,
        // Time
        ...timeTypes,
    };
}
